import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.scss';
import {homePage} from './home/homePage'

ReactDOM.render(
  <homePage/>,
  document.getElementById('root')
);
